import Component from '../core/Component'
import Pikaday from 'pikaday'
import moment from 'moment'
import {triggerEvent} from '../utils/dom'

export const defaults = {
    i18n: {
        previousMonth : 'Předchozí měsíc',
        nextMonth     : 'Následující měsíc',
        months        : ['Leden','Únor','Březen','Duben','Květen','Červen','Červenec','Srpen','Září','Říjen','Listopad','Prosinec'],
        weekdays      : ['Neděle','Pondělí','Úterý','Středa','Čtvrtek','Pátek','Sobota'],
        weekdaysShort : ['Ne', 'Po','Út','St','Čt','Pá','So']
    }
}

export default class Datepicker extends Component {

    constructor(element) {
        super(element, defaults)
    }

    prepare() {
        this.picker = new Pikaday({
            field: this.element,
            format: 'D.M.YYYY',
            i18n: this.options.i18n,
            firstDay: 1,
            onSelect: () => {
                $(this.element).trigger('keyup')
            }
        })
    }

    reset(silent = false) {
        this.picker.setDate('', silent)
    }
}